import React, { useState, useEffect } from "react";
import {
    Accordion,
    Alert,
} from "react-bootstrap";
import { useSubheader } from "@metronic/layout";
import { HospitalData } from "@components/panels/hospital-data/hospital-data";
import { InssuredData } from "@components/panels/insured-data/inssured-data";
import { Documentation } from "@components/panels/documentation/documentation";
import { Binnacle } from "@components/panels/binnacle/binnacle";
import AuthLetters from "@components/panels/auth-letter/auth-letters";
import { AdminData } from "@components/panels/admin-data/admin-data";
import {
    getBySlug,
} from "@services/hospitalization";
import { getLastLetterMovByCase } from "@services/letter-movements";
import { MedicalFees } from "@components/panels/medical-fee/medical-fees";
import CaseHeader from "@components/panels/case-header/case-header";
import BlockCaseContext from "@contexts/block-case-context";

const CompletedCasesDetails = (props) => {
    const subheader = useSubheader();

    const { slug } = props.match.params;

    const [caseRecord, setCaseRecord] = useState({});
    const [letterMov, setLetterMov] = useState({});
    const [totalLetters, setTotalLetters] = useState("0");
    const [shouldBlockCase, setShouldBlockCase] = useState(true);

    useEffect(() => {
        getBySlug(slug).then((response) => {
            setCaseRecord(response.data);
            window.requires_tabulation = response.data.requiresTabulation;
            getLastLetterMovByCase(response.data.id).then((currrentLetterMov) =>
                setLetterMov(currrentLetterMov.data)
            );
        });

        subheader.setTitle("Casos Finalizados");
    }, [slug]);

    return (
        <>
            <Alert
                variant="success"
                className="text-center"
                style={{ fontSize: "16px" }}
            >
                Casos Finalizados
            </Alert>

            <CaseHeader
                caseRecord={caseRecord}
                requiresTabulationSlot={
                    <>
                        <b>Tabulacion: </b>
                        {caseRecord.requiresTabulation}
                    </>
                }
            />

            <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
                <Accordion defaultActiveKey="0" className="mt-5">
                    <InssuredData
                        icon="fa-search"
                        eventKey="1"
                        data={caseRecord}
                        disabledAll={true}
                        bindSubmitForm={()=>{}}
                    />
                    <HospitalData
                        icon="fa-search"
                        eventKey="2"
                        data={caseRecord}
                        disabledAll={true}
                        bindSubmitForm={()=>{}}
                    />
                    <AdminData
                        icon ="fa-search"
                        data={caseRecord}
                        eventKey="0"
                        letterMov={letterMov}
                        totalLetters={totalLetters}
                        bindSubmitForm={() => {}}
                    />
                    <AuthLetters
                        icon="fa-search"
                        showForm={false}
                        hideDeleteOption={true}
                        eventKey="3"
                        data={caseRecord}
                        disabledAll={false}
                        setTotalLetters={setTotalLetters}
                        {...props}
                    />
                    <Documentation
                        icon ="fa-search"
                        eventKey="4"
                        data={caseRecord}
                        disabledAll={true}
                        {...props}
                    />
                    <MedicalFees
                        icon ="fa-search"
                        eventKey="6"
                        data={caseRecord}
                        {...props}
                    />
                </Accordion>
                <Accordion defaultActiveKey="5" className="mt-5">
                    <Binnacle
                        icon ="fa-search"
                        eventKey="5"
                        data={caseRecord}
                        disabledAll={true}
                        hideButton={true}
                        eventStage="Alta Paciente"
                        {...props}
                    />
                </Accordion>
            </BlockCaseContext.Provider>
        </>
    );
};

export default CompletedCasesDetails;

